import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/icons-alert/ilust-voice.svg'


const _hoisted_1 = { class: "flex flex-row items-center space-x-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icon-voice",
  class: "w-[37px]"
}, null, -1)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _directive_motion = _resolveDirective("motion")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    ref: "speechBubble",
    initial: {
      opacity: 0,
    },
    enter: {
      opacity: 1,
    },
    class: _normalizeClass(`start-chat-box ${_ctx.msg[_ctx.msgType]?.background} ${_ctx.msg[_ctx.msgType]?.borderColor} w-[90%] min-w-[240px] max-w-[280px] sm:min-w-[580px] sm:w-[28%] min-h-[100px] bottom-[125px] right-1/2 translate-x-[55%] sm:right-auto sm:translate-x-0 xl:mr-[100px] drop-shadow-lg z-30 border-b-4 border-r-4 rounded-t-2xl rounded-bl-2xl flex justify-between p-3 sm:p-8 flex-col space-y-3 sm:space-y-6`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", {
        class: "font-[800]",
        innerHTML: _ctx.msg[_ctx.msgType]?.title
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("p", {
      innerHTML: _ctx.msg[_ctx.msgType]?.body
    }, null, 8, _hoisted_4),
    (_ctx.msg[_ctx.msgType]?.button.show)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          class: "btn-primary h-10",
          onClick: _ctx.msg[_ctx.msgType]?.button.action
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.msg[_ctx.msgType]?.button.title), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ], 2)), [
    [_directive_motion]
  ])
}